import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './FJFake3dPreview.module.less';
import FJFake3dPreviewItem from '../FJFake3dPreviewItem/FJFake3dPreviewItem';
import { PRE_SET_LIST } from '../../../config/dataConfig/FJFake3dData';
import FJLocalStore from '../../../store/FJLocalStore';
import { useEffect, useRef, useState } from 'react';
import FJUtil from '../../../util/FJUtil';
const GAP = 12;
const PADDING = 21;
const FJFake3dPreview = props => {
    const { editPreset, active } = props;
    const containerRef = useRef(null);
    const listRef = useRef(null);
    const titleRef = useRef(null);
    const [viewSize, setViewSize] = useState({
        width: 374,
        height: 374,
    });
    const _updateUI = FJUtil.throttle(() => {
        if (containerRef.current && listRef.current && titleRef.current) {
            const titleHeight = titleRef.current.getBoundingClientRect().height + 30;
            const { width, height } = containerRef.current.getBoundingClientRect();
            const h = (height - titleHeight - PADDING * 2 - GAP) / 2;
            const w = (width - PADDING * 2 - GAP * 2) / 3;
            const pixel = Math.min(w, h);
            setViewSize({ width: pixel, height: pixel });
            listRef.current.style.width = `${(pixel + GAP) * 3}px`;
            listRef.current.style.height = `${(pixel + GAP) * 2}px`;
        }
    }, 100);
    useEffect(() => {
        _updateUI();
        window.addEventListener('resize', _updateUI);
        return () => {
            window.removeEventListener('resize', _updateUI);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className={classNames(styles.container)} ref={containerRef} style={{ display: active ? 'flex' : 'none' }}>
            <div className={styles.title} ref={titleRef}>
                {FJLocalStore._('start-fast-with-these-preset-images')}
            </div>
            <div className={styles.list} ref={listRef}>
                {PRE_SET_LIST.map((item, idx) => (
                    <FJFake3dPreviewItem
                        key={idx}
                        data={item}
                        editPreset={editPreset}
                        width={viewSize.width}
                        height={viewSize.height}
                    />
                ))}
            </div>
        </div>
    );
};

FJFake3dPreview.propTypes = {
    editPreset: PropTypes.func,
    active: PropTypes.bool,
};

export default FJFake3dPreview;
